export default __webpack_public_path__ + "20d412981c7ee51847e2b430bbf30db2.jpg";